export default "__VITE_ASSET__BYzCS7NM__"